import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ isAuthenticated, ...restProps }) =>
  isAuthenticated ? <Route {...restProps} /> : <Redirect to='/login' />;

export default PrivateRoute;
